import * as api from "@/api/williams/contractors";
import { ContractorFilters } from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useContractorList(filters: Partial<ContractorFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.contractor.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getContractors({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
